module.exports = __webpack_public_path__ + "img/tentaculo-n.b656d47e.png";